import { ProductionAccordion, ProductionDossierAttachments, ProductionField } from "../ProductionBlocks";
import { hasAnyText, hasRows } from "../bisDossierData";
import { productionFieldGridStyle, productionInputStyle } from "../bisProductionStyles";

export function renderPostProductionTab(view) {
    const { activePostProductionBlockKey, setActivePostProductionBlockKey, updateSection, uploadAttachments, workspace } = view;
    const postProductionAttachments = (workspace.formData.piecesJointes || []).filter(attachment => attachment.section !== "preprodPoint6");
    const postProductionBlocks = [
        {
            key: "pouchInspector",
            title: "7. Contrôle POUCH INSPECTOR",
            complete: hasRows(postProductionAttachments),
            countLabel: `${postProductionAttachments.length} document${postProductionAttachments.length > 1 ? "s" : ""}`,
            content: (
                <ProductionDossierAttachments
                    dossierId={workspace.activeDossier.id}
                    attachments={postProductionAttachments}
                    uploading={workspace.attachmentUploading}
                    onUpload={uploadAttachments}
                    onDelete={workspace.deleteAttachment}
                />
            ),
        },
        {
            key: "reparationControleFinal",
            title: "8. Réparation et controle final",
            complete: hasAnyText(Object.values(workspace.formData.reparationControleFinal || {})),
            content: (
                <div style={productionFieldGridStyle}>
                    <ProductionField label="Reparation effectuee par"><input style={productionInputStyle} value={workspace.formData.reparationControleFinal.realisePar || ""} onChange={e => updateSection("reparationControleFinal", { realisePar: e.target.value })} /></ProductionField>
                    <ProductionField label="Controle PI"><input style={productionInputStyle} value={workspace.formData.reparationControleFinal.controlePi || workspace.formData.reparationControleFinal.controlePar || ""} onChange={e => updateSection("reparationControleFinal", { controlePi: e.target.value })} /></ProductionField>
                    <ProductionField label="Pontage Rouleaux + edition bon de livraison"><input style={productionInputStyle} value={workspace.formData.reparationControleFinal.pontageRouleaux || workspace.formData.reparationControleFinal.pointageMachine || ""} onChange={e => updateSection("reparationControleFinal", { pontageRouleaux: e.target.value })} /></ProductionField>
                    <ProductionField label="Date et heure"><input style={productionInputStyle} type="datetime-local" value={workspace.formData.reparationControleFinal.dateHeure || ""} onChange={e => updateSection("reparationControleFinal", { dateHeure: e.target.value })} /></ProductionField>
                </div>
            ),
        },
    ];
    return (
        <ProductionAccordion
            label="Progression post-production"
            blocks={postProductionBlocks}
            activeKey={activePostProductionBlockKey}
            onActiveKeyChange={setActivePostProductionBlockKey}
        />
    );
}
